export const submitFormWithFormData = (action: string, formData: FormData) => {
  const to = new URL(action);
  for (const [k, v] of formData.entries()) {
    to.searchParams.append(k, (v as string));
  }
  window.location.href = String(to);
};

export function getCommentsTranslatePL(comments?: number): string {
  switch (comments) {
    case 1: return 'opinia';
    case 2:
    case 3:
    case 4: return 'opinie';
    default: return 'opinii';
  }
}

export function loadScript(src: string, async: boolean = false, crossOrigin: string | undefined = 'anonymous') {
  return new Promise(function (resolve, reject) {
    let s;
    s = document.createElement('script');
    s.src = src;
    s.async = async;
    s.crossOrigin = crossOrigin;
    s.onload = resolve;
    s.onerror = reject;
    document.head.appendChild(s);
  });
}

export function convertMapZoomToMeters(cordsNortEast: any, cordsSouthWest: any): number {
  if (!cordsNortEast || !cordsSouthWest) return 10000;

  const R = 6371e3; // metres
  const φ1 = cordsNortEast.lat() * Math.PI / 180; // φ, λ in radians
  const φ2 = cordsSouthWest.lat() * Math.PI / 180;
  const Δφ = (cordsSouthWest.lat() - cordsNortEast.lat()) * Math.PI / 180;
  const Δλ = (cordsSouthWest.lng() - cordsSouthWest.lng()) * Math.PI / 180;

  const a = Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
    Math.cos(φ1) * Math.cos(φ2) *
    Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  const d = R * c; // in metres

  return d / 2;
}

export function capitalizeFirstLetter(val?: string | null): string {
  const text = `${val?.toLowerCase()}`;
  return String(text).charAt(0).toUpperCase() + String(text).slice(1);
}